// extracted by mini-css-extract-plugin
export default {"container":"ap-z","ratingLayout":"bp-z","ratingLabel":"cp-z","nonInteractiveRatingLabel":"dp-z"};